/** Rewritten only by the package-profile script. Source defaults to certification-oriented core mode. */
export const EXTERNAL_PROVIDERS_AVAILABLE = false;
